import React, { Suspense, useState } from 'react';
import { Icon, ICONS_ENUM } from '@sanlam-glacier/app-common/components';
import { CustomDevToolsMenuItem, DevToolsMenuItem } from './dev-tools-menu.type';
import { DevToolsMenuItems } from './dev-tools-menu.function';
import { useConfig } from 'providers/config/ConfigProvider';
import { useAtomValue } from 'jotai';
import { customDevToolAtom } from 'stores/jotai.store';
import { DevToolsContent } from './components/dev-tools-content/DevToolsContent';
import menuStyles from './menu.module.scss';

const ReactQueryDevtools = React.lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then((d) => ({
    default: d.ReactQueryDevtools
  }))
);

export const DevToolsMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState<DevToolsMenuItem>();
  const [currentCustomItem, setCurrentCustomItem] = useState<CustomDevToolsMenuItem>();
  const customDevTool = useAtomValue(customDevToolAtom);

  const {
    featureFlags: { devtools }
  } = useConfig();

  const closeCustomDevTool = () => {
    if (customDevTool) customDevTool.toggleMenu(false);
    setCurrentCustomItem(undefined);
  };

  const toggleContentOpen = () => {
    setIsOpen(!isOpen);
    setCurrentItem(undefined);
    closeCustomDevTool();
  };

  const handleMenuItemClick = (item: DevToolsMenuItem) => {
    if (currentItem && currentItem.id === item.id) {
      setCurrentItem(undefined);
      return;
    }
    setCurrentItem(item);
    closeCustomDevTool();
  };

  const handleCustomMenuItemClick = (item: CustomDevToolsMenuItem) => {
    if (currentCustomItem && currentCustomItem.id === item.id) {
      closeCustomDevTool();
      return;
    }
    setCurrentCustomItem(item);
    setCurrentItem(undefined);
    item.toggleMenu(true);
  };

  if (!devtools) return null;

  return (
    <div data-html2canvas-ignore={true}>
      <div className={menuStyles.menu}>
        {currentItem && (
          <DevToolsContent title={currentItem.name} onCloseClick={() => setCurrentItem(undefined)}>
            <currentItem.content />
          </DevToolsContent>
        )}
        <div className={menuStyles.menuContainer}>
          <Icon
            icon={ICONS_ENUM.ACTION_BUG_REPORT}
            title='Debug Tools'
            className={menuStyles.menuToggleIcon}
            onClick={toggleContentOpen}
          />
          {isOpen && (
            <>
              {DevToolsMenuItems.map((item) => (
                <Icon
                  key={item.id}
                  icon={item.icon}
                  title={item.name}
                  className={`${menuStyles.menuIcon} ${
                    currentItem?.id === item.id ? menuStyles.menuIconActive : ''
                  }`}
                  onClick={() => handleMenuItemClick(item)}
                />
              ))}
              {customDevTool && (
                <Icon
                  icon={customDevTool.icon}
                  title={customDevTool.name}
                  className={`${menuStyles.menuIcon} ${
                    currentCustomItem?.id === customDevTool.id ? menuStyles.menuIconActive : ''
                  }`}
                  onClick={() => handleCustomMenuItemClick(customDevTool)}
                />
              )}
              <div className={menuStyles.tanstackQueryContainer}>
                <Suspense fallback={null}>
                  <ReactQueryDevtools position='right' buttonPosition='bottom-right' />
                </Suspense>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
